import i18n from "../../i18n";
import { createSelector } from "reselect";
import { getHasCoachingSession } from "@microdoing/shared/services/coaching/selectors";
import { getHasResources } from "@microdoing/shared/services/resources/selectors";
import { AppState } from "../rootReducer";

const TABS = [
  {
    index: 0,
    name: "Home",
    icon: "home",
    tabBarTestID: "tab-home",
    label: "tabBar-action-title",
    barColor: "#fff",
    pressColor: "rgba(255, 255, 255, 0.16)",
  },
  {
    index: 1,
    name: "Team",
    icon: "team",
    tabBarTestID: "tab-team",
    label: "tabBar-team-title",
    barColor: "#fff",
    pressColor: "rgba(255, 255, 255, 0.16)",
  },
  {
    index: 2,
    name: "Progress",
    icon: "progression",
    tabBarTestID: "tab-progression",
    label: "tabBar-progression-title",
    barColor: "#fff",
    pressColor: "rgba(255, 255, 255, 0.16)",
  },
  {
    index: 3,
    name: "Coaching",
    icon: "coaching",
    tabBarTestID: "tab-coaching",
    label: "tabBar-coaching-title",
    barColor: "#fff",
    pressColor: "rgba(255, 255, 255, 0.16)",
    hasCoachingSession: true,
  },
  {
    index: 4,
    name: "Notification",
    icon: "ios-notifications",
    tabBarTestID: "tab-notification",
    label: "tabBar-notification-title",
    barColor: "#fff",
    pressColor: "rgba(255, 255, 255, 0.16)",
  },
  {
    index: 5,
    name: "UserProfile",
    icon: "ios-contact",
    tabBarTestID: "tab-profile",
    label: "tabBar-profile-title",
    barColor: "#fff",
    pressColor: "rgba(255, 255, 255, 0.16)",
  },
];

const WEBTABS = [
  {
    index: 0,
    key: "Home",
    route: "DailyFocusScreen",
    icon: "homelight",
    tabBarTestID: "tab-home",
    label: i18n.t("breadcrumb-campaign"),
  },
  {
    index: 1,
    key: "Progress",
    route: "ProgressScreen",
    icon: "progress",
    tabBarTestID: "tab-progress",
    label: i18n.t("breadcrumb-progress"),
    hasResources: true,
  },
  {
    index: 2,
    key: "Team",
    route: "TeamScreen",
    icon: "team",
    tabBarTestID: "tab-team",
    label: i18n.t("breadcrumb-team"),
  },
  {
    index: 3,
    key: "Message",
    route: "Message",
    icon: "messages",
    tabBarTestID: "tab-chat",
    label: i18n.t("breadcrumb-conversations"),
  },
  {
    index: 4,
    key: "Notification",
    route: "Notifications",
    icon: "ios-notifications",
    tabBarTestID: "tab-notification",
    label: i18n.t("breadcrumb-notifications"),
  },
];

export const getFirstName = (state: AppState) =>
  state.profileSettings.firstName || "";

export const getLastName = (state: AppState) =>
  state.profileSettings.lastName || "";

export const getBio = (state: AppState) => state.profileSettings.bio || "";

export const getJobDuration = (state: AppState) =>
  state.profileSettings.jobDuration || 0;

export const getJobDescription = (state: AppState) =>
  state.profileSettings.jobDescription || "";

export const getManager = (state: AppState) =>
  state.profileSettings.manager || false;

export const getBirthDate = (state: AppState) =>
  state.profileSettings.birthDate || "";

export const getMbti = (state: AppState) => state.user.mbti || state.profileSettings.mbti || "";

export const getDisc = (state: AppState) => state.profileSettings.disc || "";

export const getLanguage = (state: AppState) =>
  state.profileSettings.language || "en";

export const getReminderTime = (state: AppState) =>
  state.profileSettings.reminderTime;

export const getNumberOfReminders = (state: AppState) =>
  state.profileSettings.numberOfReminders;

export const getFirstReminderTime = (state: AppState) =>
  state.profileSettings.firstReminderTime || { hour: 9, minute: 30 };

export const getSecondReminderTime = (state: AppState) =>
  state.profileSettings.secondReminderTime || { hour: 17, minute: 20 };

export const getThirdReminderTime = (state: AppState) =>
  state.profileSettings.thirdReminderTime || { hour: 14, minute: 30 };

export const getNotifTime = (state: AppState) =>
  state.profileSettings.notifTime || { hour: 14, minute: 30 };

export const getIsReminderChecked = (state: AppState) =>
  state.profileSettings.isReminderChecked;

export const getPaceGoal = (state: AppState) => state.profileSettings.paceGoal;

export const getReminderDays = (state: AppState) =>
  state.profileSettings.reminderDays;

export const getProfileSettingsDisc = (state: AppState) =>
  state.profileSettings.disc;

export const getProfileSettingsMbti = (state: AppState) =>
  state.profileSettings.mbti;

export const getAlertMessage = (state: AppState) =>
  state.profileSettings?.alertMessage || {};

export const getProfilSettingsLoading = (state: AppState) =>
  state.profileSettings.loading;

export const getTabs = createSelector(
  getLanguage,
  getHasResources,
  getHasCoachingSession,
  (language, hasResources, hasCoaching) => {
    return TABS.filter(el => {
      if (el.hasCoachingSession && !hasCoaching) return false;
      return true;
    });
  },
);

export const getWebDesktopTabs = createSelector(
  getLanguage,
  getHasResources,
  getHasCoachingSession,
  () => {
    return WEBTABS;
  },
);
